import { APP_PREFIX_PATH } from '@constants/common';
import { useAppDispatch } from '@hooks/generic';
import { Box } from '@mui/material';
import { setBreadcrumbs } from '@store/breadcrumbSlice';
import { HighlightedVideos } from '@videos/routes/VideosOverview/HighlightedVideos';
import { VideosList } from '@videos/routes/VideosOverview/VideosList';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

export const VideosOverview = () => {
    const intl = useIntl();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(
            setBreadcrumbs([
                {
                    label: intl.formatMessage({ id: 'videos', defaultMessage: 'Videos' }),
                    to: APP_PREFIX_PATH + '/videos',
                },
            ])
        );
    }, [dispatch, intl]);

    return (
        <>
            <title>
                {intl.formatMessage(
                    { id: 'videos.browserTitle', defaultMessage: '{brand} - Videos' },
                    { brand: 'Victron Professional' }
                )}
            </title>
            <Box px={{ xs: 2, md: 4 }}>
                <HighlightedVideos />
            </Box>
            <VideosList />
        </>
    );
};
